import {IsoFields, LocalDate} from "js-joda";
import {months} from "../../util/timeDescription";

export const isContainedIn = (startDate, endDate, queryDate) => {
    return queryDate.compareTo(startDate) >= 0 && queryDate.compareTo(endDate) <= 0;
};

export const RewardPeriods = {
    Month: {
        activeLabel: "MTD",
        endDate(startDate) {
            return startDate.plusMonths(1).minusDays(1);
        },
        format(startDate, isPreviousYear) {
            const yearPortion = isPreviousYear ? `${startDate.year()} ` : "";
            return `${yearPortion}${months[startDate.monthValue() - 1]}`;
        }
    },
    Quarter: {
        activeLabel: "QTD",
        endDate(startDate) {
            return startDate.plusMonths(3).minusDays(1);
        },
        format(startDate, isPreviousYear) {
            const yearPortion = isPreviousYear ? `${startDate.year()} ` : "";
            return `${yearPortion}Q${startDate.get(IsoFields.QUARTER_OF_YEAR)}`;
        }
    },
    Year: {
        activeLabel: "YTD",
        endDate(startDate) {
            return startDate.plusYears(1).minusDays(1);
        },
        format(startDate, _isPreviousYear) {
            return `${startDate.year()}`;
        }
    }
};

export const PerformancePeriod = {
    LastMonth:          { rewardPeriod: RewardPeriods.Month,    activeLabel: "Last Month" },
    LastQuarter:        { rewardPeriod: RewardPeriods.Quarter,  activeLabel: "Last Quarter" },
    LastYear:           { rewardPeriod: RewardPeriods.Year,     activeLabel: "Last Year" },

    MonthToDate:        { rewardPeriod: RewardPeriods.Month,    activeLabel: "This Month" },
    QuarterToDate:      { rewardPeriod: RewardPeriods.Quarter,  activeLabel: "This Quarter" },
    YearToDate:         { rewardPeriod: RewardPeriods.Year,     activeLabel: "This Year" },

    SevenDaysToDate:    { rewardPeriod: RewardPeriods.Month,    activeLabel: "Last 7 Days" },
    ThirtyDaysToDate:   { rewardPeriod: RewardPeriods.Month,    activeLabel: "Last 30 Days" },

    ThreeMonthsToDate:  { rewardPeriod: RewardPeriods.Quarter,  activeLabel: "Last 3 Months" },
    SixMonthsToDate:    { rewardPeriod: RewardPeriods.Quarter,  activeLabel: "Last 6 Months" },
    InceptionToDate:    { rewardPeriod: RewardPeriods.Quarter,  activeLabel: "Since Inception" },

    TwelveMonthsToDate: { rewardPeriod: RewardPeriods.Year,     activeLabel: "Last 12 Months" },
};

export function performancePeriodLabelForActivePeriod(periodBasis) {
    if (!periodBasis) {
        return "";
    }

    const period = PerformancePeriod[periodBasis];
    return period ? period.activeLabel : periodBasis;
}

export function currentRewardPeriod(periodBasis) {
    if (!periodBasis) {
        return "";
    }

    return PerformancePeriod[periodBasis].rewardPeriod.activeLabel;
}

export function rewardPeriodLabel(p, viewingOnDate) {
    const startDate = LocalDate.parse(p.startDate);
    const rewardPeriod = RewardPeriods[p.periodBasis];

    if (!rewardPeriod) {
        return "";
    }

    const endDate = rewardPeriod.endDate(startDate);
    const isCurrentlyActive = isContainedIn(startDate, endDate, viewingOnDate);
    const isPreviousYear = startDate.year() < viewingOnDate.year();

    return isCurrentlyActive ? rewardPeriod.activeLabel : rewardPeriod.format(startDate, isPreviousYear);
}